export enum MessageType {
  Text = 'TEXT',
  Template = 'TEMPLATE',
  Sticker = 'STICKER',
  TextWithButtons = 'TEXT_WITH_BUTTONS',
  Callback = 'CALLBACK',
  Image = 'IMAGE',
  Document = 'DOCUMENT',
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Voice = 'VOICE',
  Contact = 'CONTACT',
  Location = 'LOCATION',
  Parent = 'PARENT',
  Reaction = 'REACTION',
  Reels = 'REELS'
}

export enum SenderType {
  user = 'USER',
  bot = 'BOT',
  humanAgent = 'HUMAN_AGENT',
  auto = 'AUTO',
  messenger = 'MESSENGER_APP',
  virtual = 'VIRTUAL'
}

export enum EndpointRank {
  owner = 'OWNER',
  virtual = 'VIRTUAL',
  guest = 'GUEST'
}

export enum MessageStatus {
  read = 'READ',
  delivered = 'DELIVERED',
  sent = 'SENT',
  failed = 'FAILED'
}
